module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADHSURBVEhL7YyxDQIxEASfhIyYBuiAHiiCNmiDNiiCChASHdAAMRkJsCu9JWvv7HuDwx9pJMt7u8NMTxbwOMp3V5bwBD+jfPOvCyt4hmk8yT9mf7GGN6jjSWa8+YkNvENvOJc3vG1iCx/QG/TkLTuT2MEn9IZqssNulT18QW9giuxyw+UA39ArtsgNbhVJh0o+UjOkdJiP1AwpHUb/pdxQOoz+S7lBC6oS5QYtqEqUG7SgKlFu0IKqRLnhCrWUq+TZhR8zDQzDFxxTvNX5y+P7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-exterior/dark/24.png
// module id = 2022
// module chunks = 2